import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import ReportsRequestBody from "./ReportsRequestBody";


export default class ReportsService {
    request = new ReportsRequestBody();
    static shared = new ReportsService();

    reportsProjectsByIdRequest = (payload) => {
        return new Promise((resolve, reject) => {
         WebService.clientShared
            .callServiceApi(
                ApiUrl.getProjectsByuserId(payload.employee,payload.startDate,payload.endDate),
                this.request.reportsProjectsByIdRequest(REQUEST_METHOD.GET)
            )
            .then((response) => {
                resolve(response);
        })
        .catch((error) => {
            reject(error);
          });
    });
}


    BudgetReportByProjectRequest = (payload) => {
    return new Promise((resolve, reject) => {
     WebService.clientShared
        .callServiceApi(
            ApiUrl.getBudgetByProjectId(payload.projectName),
            this.request.budgetReportByProjectIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
            resolve(response);
    })
    .catch((error) => {
        reject(error);
      });
});
}


generateReportRequest = (payload) => {
    return new Promise((resolve, reject) => {
     WebService.clientShared
        .callServiceApi(
            ApiUrl.generateProjectReport(payload),
            this.request.generateReportRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
            resolve(response);
    })
    .catch((error) => {
        reject(error);
      });
});
}

}